export function scrollToElement(
  elementId: string,
  layoutId = '.layout-page__overflow',
  intervalTime = 0,
  scrollTime = 0,
): void {
  const getElement = (): HTMLElement | null => document.getElementById(elementId);

  const scrollEvent = (): void => {
    getElement()?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  setTimeout(scrollEvent, scrollTime);

  if (getElement() === null) {
    const layoutPage = document.querySelector<HTMLElement>(layoutId);
    if (!layoutPage) return;

    layoutPage.scrollTo(0, layoutPage.scrollHeight);

    const intervalId = setInterval(() => {
      const el = getElement();
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        clearInterval(intervalId);
      } else {
        layoutPage.scrollTo(0, layoutPage.scrollHeight);
      }
    }, intervalTime);

    layoutPage.addEventListener('scroll', function handler() {
      clearInterval(intervalId);
      layoutPage.removeEventListener('scroll', handler);
    });
  }
}

export default scrollToElement;
